module.exports = __webpack_public_path__ + "img/1-place-medal.22a153e4.svg";